import { useMutation, useQueryClient } from "@tanstack/react-query";
import { axios } from "../../../shared/lib/axios";
import { createNotification } from "../../../shared/store/notifications";

export const setStudentApprovalStatus = ({ enrollmentId, situation }) => {
  const body = new FormData();
  body.append(
    "dados",
    JSON.stringify([
      {
        matriculaid: enrollmentId,
        situacao: situation,
      },
    ])
  );
  return axios.middleware.post("/Backend.asmx/BK_Atualiza_Situacao", body);
};

export const useSetStudentApprovalStatus = ({ config, courseId } = {}) => {
  const queryClient = useQueryClient();
  return useMutation({
    ...config,
    mutationFn: setStudentApprovalStatus,
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["diaryCourse", { courseId }],
      });
      createNotification({
        type: "success",
        message: "Situação atualizada com sucesso",
      });
    },
  });
};
